import { createContext, useContext, useEffect } from "react";

/**
 * Allows modal content to register header content with the Modal shell so it
 * is rendered in the header area (below title).
 * Modal reads headerContent from context; modal content uses useModalHeader(node).
 */
export const ModalHeaderContext = createContext(null);

/**
 * Set the modal header content. Shown in the Modal shell (below title).
 * Clears on unmount.
 * @param {React.ReactNode} headerContent - Header content (e.g. beta notice)
 * @param {Array} deps - Optional dependency array; effect re-runs when these change
 */
export function useModalHeader(headerContent, deps = []) {
  const value = useContext(ModalHeaderContext);
  const setHeader = value?.[1];
  useEffect(() => {
    if (setHeader) setHeader(headerContent ?? null);
    return () => {
      if (setHeader) setHeader(null);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- deps intentionally control when to push latest header
  }, [setHeader, ...deps]);
}
